// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_4r-6";
export var headerCell = "_4r-2";
export var rowWrapper = "_4r-4";
export var stickyAggregationCell = "_4r-a";
export var stickyAggregationRow = "_4r-7";
export var stickyColumnCell = "_4r-9";
export var stickyColumnHeaderCell = "_4r-8";
export var table = "_4r-1";
export var virtualRowWrapper = "_4r-5";
export var virtualTableContainer = "_4r-0";
export var white = "_4r-3";